import { Controller } from "@hotwired/stimulus";

// A row of tabs that scrolls sideways (walk/ORG.md § 3): the open one, past
// the edge at 375, is scrolled to the middle. Measured from the row itself,
// never offsetLeft (that is the drawer's, rail and gutter included), and only
// the row moves: scrollIntoView would move the page too.
export default class extends Controller {
  connect() {
    const open = this.element.querySelector('[aria-current="page"]');
    if (!open) return;

    const row = this.element;
    const from = open.getBoundingClientRect().left - row.getBoundingClientRect().left + row.scrollLeft;
    row.scrollLeft = from - (row.clientWidth - open.offsetWidth) / 2;
  }
}
